/**
 * Created by lingcy on 2017/3/15.
 */

import {hashHistory} from 'react-router';
import zh_cn from './zh_CN';
import en_US from './en_US';


export function errorShow(id ,errorMessage) {
    let error = '';
    if(errorMessage == ''||errorMessage == undefined){
        error = language()['IncompleteInformation'];
    }else {
        error = errorMessage;
    }

    $("#error_"+id).html(error);
    $("#error_"+id).attr("name","error");
    $("#error_"+id).parent().attr("class","errmsgtop");
    $("#error_"+id).siblings().attr("class","triangle-down");
    $("#"+id).focus();
}
const history = hashHistory;
export const getUserId = () => {
    return sessionStorage.getItem("userId");
}

export const getProductId = () => {
    return sessionStorage.getItem("productId");
}

export  const getMenuId =() =>{
    return sessionStorage.getItem("menuId")
}
export  const getToken =() =>{
    return sessionStorage.getItem("token")
}

export const myhref = (url) => {
    history.push(url);
}

export  const  removeByValue = (arr, val) =>{
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
            arr.splice(i, 1);
            break;
        }
    }
}
export const errToSuc =()=> {
    $("[name='error']").each(function () {
        var this_id = $(this).attr('id');
        $("#"+this_id).html('');
        $("#"+this_id).attr("name","success");
        $("#"+this_id).parent().attr("class","");
        $("#"+this_id).siblings().attr("class","");
    });
}
//返回结果弹窗
export const resultTip = (data,url) => {
        errToSuc();
    $("#success_tip").addClass("hidden");
    $("#warning_tip").addClass("hidden");
    $("#error_tip").addClass("hidden");
    if (data.code == 8001) {
        $("#success_msg").text(data.msg);
        $("#success_tip").removeClass("hidden");
        $("#success_tip").focus();
        setTimeout(function () {
            $("#success_tip").addClass("hidden");
            if(url != undefined && url != "" && url != null){
                myhref(url);
            }
        }, 3000);
    } else {
        $('#btnSubmit').removeAttr("disabled");
        console.log(data);
        if (data.data instanceof Array) {
            var errorList = data.data;
            for(const i in errorList){
                const code = errorList[i].code;
                $("#error_"+code).html(errorList[i].message||errorList[i].msg);
                $("#error_"+code).attr("name","error");
                $("#error_"+code).parent().attr("class","errmsgtop");
                $("#error_"+code).siblings().attr("class","triangle-down");
                $("#"+code).focus();
            }
        } else {
            const errorMessage = data.message||data.msg;
            $("#error_msg").text(errorMessage);
            $("#error_tip").removeClass("hidden");
            $("#error_tip").focus();
            setTimeout(function () {
                $("#error_tip").addClass("hidden");
            }, 4000);
        }

    }
}
//警告弹窗
export const alertTip = (msg) => {
    $("#warning_msg").text(msg);
    $("#warning_tip").removeClass("hidden");
    $("#warning_tip").focus();
    setTimeout(function () {
        $("#warning_tip").addClass("hidden");
    }, 4000);
}

export const inputOnChange = id => {
    $("#error_" + id).addClass('hidden')
}
//授权的select
export function selectTwo() {
    $('#add').click(function () {
        //获取选中的选项，删除并追加给对方
        $('#select1 option:selected').appendTo('#select2');
    });

    //移到左边
    $('#remove').click(function () {
        $('#select2 option:selected').appendTo('#select1');
    });

    //全部移到右边
    $('#add_all').click(function () {
        //获取全部的选项,删除并追加给对方
        $('#select1 option').appendTo('#select2');
    });

    //全部移到左边
    $('#remove_all').click(function () {
        $('#select2 option').appendTo('#select1');
    });

    //双击选项
    $('#select1').dblclick(function () { //绑定双击事件
        //获取全部的选项,删除并追加给对方
        $("option:selected", this).appendTo('#select2'); //追加给对方
    });

    //双击选项
    $('#select2').dblclick(function() {
        $("option:selected", this).appendTo('#select1');
    })

}

//国际化
// export const  language =()=>{
//     const languages = navigator.languages;
//     const currentLang = languages==undefined?navigator.language:languages[1];
//     var  language = {}
//     if(currentLang == 'en'){
//         language = en_US;
//     }
//     else {
//         language = zh_cn;
//     }
//     return language
// }

import languages from './language';
export const language =()=>{
    return languages
}
export const successShow=(id)=>{
    $("#error_"+id).html('');
    $("#error_"+id).attr("name","success");
    $("#error_"+id).parent().attr("class","");
    $("#error_"+id).siblings().attr("class","");
}

export const pageOption = (page,pageSize)=>{
    const options = {
        noDataText: language()["noDataText"],
        page: page, //当前页
        sizePerPageList: [10, 15, 20],
        sizePerPager: pageSize, //，每页多少值
        pageStartIndex: 1,
        paginationSize: 5,
        prePage: '《',
        nextPage: '》',
        firstPage: language()['firstPage'],
        lastPage: language()['lastPage'],
    };
    return options;
}




// WEBPACK FOOTER //
// ./modules/utils/common.js